import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const _GetMarginRequestDtoSchema = z.object({
  facilityId: z.number(),
  from: z.string(),
  to: z.string(),
  comparisonSet: z.enum(['INTERNAL', 'COMP']).optional(),
});

const GetMarginResponseDtoSchema = z.object({
  marketMedian: z.number().nullable(),
  currentValue: z.number().nullable(),
  hint: z.string(),
  message: z.string(),
});

export type GetMarginRequestDto = z.infer<typeof _GetMarginRequestDtoSchema>;
export type GetMarginResponseDto = z.infer<typeof GetMarginResponseDtoSchema>;

export const getMarginKpi = async (
  params: GetMarginRequestDto,
  config?: AxiosRequestConfig<GetMarginRequestDto>
) => {
  const { facilityId, ...restParams } = params;

  return api
    .get(`/market-intelligence/facilities/${facilityId}/margin-kpi`, {
      params: restParams,
      ...config,
    })
    .then(responseContract(GetMarginResponseDtoSchema));
};
